import { BrowserRouter, Link, Routes, Route, NavLink } from "react-router-dom";
import bootstrap from "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Home from "./pagecomponents/Home";
import Contact from "./pagecomponents/Contact";
import Portfolio from "./pagecomponents/Portfolio";
import Services from "./pagecomponents/Services";
import Formations from "./pagecomponents/Formations";
import { useState, useEffect } from "react";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Détecter la taille de l'écran
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false); // Fermer le menu si on passe en desktop
      }
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    // Empêcher le scroll quand le menu est ouvert
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      window.removeEventListener('resize', checkScreenSize);
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  // Fermer le menu quand on clique sur un lien
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="App">
      <header className="header-section">
        <BrowserRouter>
          {/* Desktop Navigation */}
          <nav className="navigation-bar desktop-nav">
            <ul className="nav nav-pills">
              <li>
                <NavLink 
                  to="/rodrigue" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link text-start ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Rodrigue E.APOTHEY
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/home" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/portfolio" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Portfolio
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/services" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/formations" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Formations
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/contact" 
                  className={({ isActive }) => 
                    `btn btn-outline-info ms-0 link ${isActive ? 'nav-active' : ''}`
                  }
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* Mobile Navigation - Hamburger + Offcanvas */}
          <div className="mobile-nav-container">
            {/* Hamburger Button */}
            <button 
              className={`hamburger-btn ${isMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            {/* Logo/Brand on mobile */}
            <div className="mobile-brand">
              <NavLink to="/home" onClick={handleLinkClick}>
                Rodrigue E.APOTHEY
              </NavLink>
            </div>

            {/* Offcanvas Menu */}
            <div className={`offcanvas-menu ${isMenuOpen ? 'open' : ''}`}>
              <div className="offcanvas-header">
                <h3>Menu</h3>
                <button 
                  className="close-btn"
                  onClick={() => setIsMenuOpen(false)}
                >
                  ✕
                </button>
              </div>
              <div className="offcanvas-body">
                <ul className="mobile-nav-links">
                  <li>
                    <NavLink 
                      to="/rodrigue" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">👤</span>
                      Rodrigue E.APOTHEY
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/home" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">🏠</span>
                      Accueil
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/portfolio" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">📁</span>
                      Portfolio
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/services" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">⚙️</span>
                      Services
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/formations" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">📚</span>
                      Formations
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/contact" 
                      onClick={handleLinkClick}
                      className={({ isActive }) => isActive ? 'active' : ''}
                    >
                      <span className="nav-icon">📧</span>
                      Contact
                    </NavLink>
                  </li>
                </ul>
                
                <div className="mobile-footer">
                  <p>© 2024 Rodrigue APOTHEY</p>
                  <div className="mobile-social">
                    <a href="https://github.com/eliletishbit" target="_blank">GitHub</a>
                    <a href="#">LinkedIn</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Overlay */}
            <div 
              className={`offcanvas-overlay ${isMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            ></div>
          </div>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/formations" element={<Formations />} />
            <Route path="/rodrigue" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;